export default __webpack_public_path__ + "static/media/xlsx.b57a1232.png";